var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgVideoHost(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 640 640"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M612.185 545.707h-.005c-7.736-.001-15.529-3.098-23.162-9.203l-110.024-88.02C461.324 434.351 448 406.628 448 384v-96c0-22.627 13.324-50.35 30.993-64.484l110.023-88.019c7.635-6.108 15.429-9.204 23.166-9.204C626.029 126.292 640 136.715 640 160v352c0 8.896-2.047 16.373-6.083 22.224-5.035 7.297-12.956 11.483-21.732 11.483zM608 161.29l-109.017 87.214C489.048 256.452 480 275.277 480 288v96c0 12.724 9.048 31.549 18.982 39.496L608 510.71V161.29zM368 544H48c-26.467 0-48-21.533-48-48V176c0-26.467 21.533-48 48-48h320c26.467 0 48 21.533 48 48v320c0 26.467-21.533 48-48 48zM48 160c-8.822 0-16 7.178-16 16v320c0 8.822 7.178 16 16 16h320c8.822 0 16-7.178 16-16V176c0-8.822-7.178-16-16-16H48z"
  })));
}

export default SvgVideoHost;